<script setup>
  import { ref, watchEffect, onMounted } from 'vue';
  import BaseModal from '@/components/base/BaseModal.vue';
  import ControlButton from '@/components/controls/ControlButton.vue';
  import Icon from '@/components/icons/Icon.vue';  
  import CopyContent from '@/components/CopyContent.vue';

  const emits = defineEmits(['close']);

  const props = defineProps({
    title: {
      type: String,
      default: 'Copy Content'
    },
    content: {
      type: [String, Number],
      required: false
    },
    show: {
      type: Boolean,
      default: false
    },    
  });

  const copied = ref(false);
  const showModal = ref(false);

  function closeModal() {
    showModal.value = false;
    emits('close'); 
  }

  onMounted(() => {
    // Placing the watchEffect in the onMounted callback makes sure
    // the BaseModal has time to run the modal open animation by delaying the 
    // showModal value being set to true until after this component mounts    
    watchEffect(() => showModal.value = props.show);
  });  

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="true"
    style="--jwx-modal-width: auto; --jwx-modal-min-width: 500px"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">{{ props.title }}</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <div class="jwx-block jwx-flex jwx-p-xxl jwx-align-center" data-surface="1">
          <p class="jwx-text jwx-no-wrap">{{ props.content }}</p>
          <CopyContent
            v-model="copied"
            v-slot="{copy}">
            <ControlButton data-shape="circle" @click="copy(props.content)" class="jwx-m-left-auto">
              <Icon v-if="copied" name="checkmark" class="jwx-button-control__icon" />
              <Icon v-else name="clipboard" class="jwx-button-control__icon" />
            </ControlButton>
          </CopyContent>
        </div>
      </div>
    </div>         
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button 
          type="button" 
          @click.prevent="closeModal"
          class="jwx-button jwx-button--success"
        >Close</button>
      </div>
    </div>
  </BaseModal>
</template>